module.exports = __webpack_public_path__ + "img/Insta.a4da6abc.png";